import { motion } from "framer-motion";

export const Depoimento = () => {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.5,
      },
    },
  };

  const imageVariants = {
    hidden: { x: -200, opacity: 0 },
    visible: { 
      x: 0, 
      opacity: 1, 
      transition: { type: "spring" as "spring", stiffness: 50, damping: 20 } 
    },
  };

  const quoteVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const authorVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0, transition: { delay: 0.8, duration: 0.5 } },
  };

  return (
    <div className="relative py-12">
      <motion.section
        className="container px-6 grid grid-cols-1 lg:grid-cols-2 items-center gap-6"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <motion.blockquote
          className="text-lg italic font-bold text-gray-800 max-w-xl text-center md:text-left md:text-4xl"
          variants={quoteVariants}
        >
          “Anilhas de excelente qualidade, sempre entregues no prazo. Recomendo!”
          <br />
          <motion.span
            className="not-italic font-semibold text-sm"
            variants={authorVariants}
          >
            Criador Técnico Aves
          </motion.span>
        </motion.blockquote>

        <motion.img
          src="/img/voando.png"
          alt="Papagaio"
          className="block lg:hidden w-full max-w-xs h-auto object-contain mx-auto mt-4"
          variants={imageVariants}
        />

        <div className="hidden lg:flex justify-end">
          <motion.img
            src="/img/voando.png"
            alt="Papagaio"
            className="w-[580.75px] h-auto max-w-none"
            variants={imageVariants}
          />
        </div>
      </motion.section>
    </div>
  );
};
